VLW.ContentController = class VLW_ContentController {
	constructor(el, config) {
		this.uid               = guid();
		this.mainElementJS     = el;
		this.autoactivate      = true;
		this.children          = [];
		this.controllersGroups = {};
		this.readyForIntro     = false;
		this.url               = null;
		this.container         = null;
		this.introDone         = false;
		this.cntr              = "";
		// this.site = config.site; DONE IN Object.assign
		Object.assign(this, config);
		this.container = document.querySelector('[data-cntr=' + this.cntr + ']');
		this.initBind(this);
		this.setEvents();
		VLW.init(this.mainElementJS, this);
	}

	setEvents() {
		this.events = {
			dolaunchnext         : new signals.Signal(),
			beforeactivate       : new signals.Signal(),
			beforedeactivate     : new signals.Signal(),
			ondeactivate         : new signals.Signal(),
			onintroready         : new signals.Signal(),
			onremove             : new signals.Signal(),
			onintroresumedbygroup: new signals.Signal(),
			onoutroready         : new signals.Signal(),
			dooutroparent        : new signals.Signal(),
		};
	}

	initBind(currCls) {
		if (currCls == null || typeof currCls === "undefined" || currCls.__proto__ == null || typeof currCls.__proto__ === "undefined") return;
		let names = Object.getOwnPropertyNames(currCls.__proto__);
		for (let memberName of names) {
			// skip getters/setters
			let descriptor = Object.getOwnPropertyDescriptor(currCls.__proto__, memberName);
			if (descriptor && (descriptor.get || descriptor.set)) {
				continue;
			}
			if (typeof(this[memberName]) === "function" && memberName !== "constructor") {
				this[memberName] = this[memberName].bind(this);
			}
		}
		this.initBind(currCls.__proto__);
	}

	onRender() {
	}

	onRemoved() {
		VLW.instanceClean(this.mainElementJS);
		(typeof this.instanceClean === "function" && this.instanceClean());
		for (let i in this.events) {
			this.events[i].removeAll();
		}
		for (let i in this) {
			if (this[i] != null && i !== "ctrl" && i !== "controllerToTrig" && typeof (this[i].instanceClean) === "function") {
				this[i].instanceClean.call(this[i]);
			}
			this[i] = null;
		}
	}

	onIntroComplete() {
		this.introDone    = true;
		this.introRunning = false;
	}

	onOutroComplete() {
		this.rendered && this.remove();
	}

	/******************************/
	// Methodes
	/******************************/
	registerController(controller) {
		let groupId = controller.grp;
		let group   = this.controllersGroups[groupId];
		if (!group) {
			let groupClass = VLW.groupControllers[groupId] || VLW.ContentGroup;
			group          = this.controllersGroups[groupId] = this.controllersGroups[groupId] || new groupClass(true);
			group.setParentController(this);
		}
		group.registerController(controller);
		this.onRegisterController(controller)
	}

	launch() {
		//(this.rendered) ? this.onRender() : this.render();
		this.activate();
	}

	activate() {
		if (this.activated) return false;
		(this.rendered) ? this.onRender() : this.render();
		this.events.beforeactivate.dispatch(this);
		this.activated = true;
		this.readyIntro();
	}

	deactivate() {
		if (!this.activated) return false;
		this.events.beforedeactivate.dispatch(this);
		(this.rendered) ? this.launchOutro() : this.outroReady();
		this.activated = false;
	}

	restoreScrollState(){
		[...this.mainElementJS.querySelectorAll('[historyScrollTop]')]
		.forEach(el => {
			el.scrollTop = el.getAttribute("historyScrollTop");
			el.scrollLeft = el.getAttribute("historyScrollLeft");
		});
	}

	render() {
		if (!this.mainElementJS || this.rendered) return;
		this.container.appendChild(this.mainElementJS);
		this.restoreScrollState();
		this.rendered = true;
		this.onRender();
		this.renderedTriggered = true;
	}

	reload(el) {
	}

	remove() {
		if (!this.rendered) return;
		this.mainElementJS && this.mainElementJS.parentNode.removeChild(this.mainElementJS);
		this.rendered = false;
		this.events.ondeactivate.dispatch(this);
		this.events.onremove.dispatch(this);
		this.onRemoved();
	}

	readyIntro() {
		this.introRunning  = true;
		this.readyForIntro = true;
		this.events.onintroready.dispatch(this);
	}

	outroReady() {
		this.events.onoutroready.dispatch(this);
		this.events.ondeactivate.dispatch(this);
	}

	launchOutro() {
		this.introRunning && this.stopIntro && this.stopIntro();
		this.outroReady();
		this.introRunning = false;
	}

	onRegisterNewInGroup(controller) {

	}

	onRegisterInGroup(group) {
		//this.parentGroup = group;
	}

	onRegisterController(e) {

	}
};

/*_deactivate() {
	if (!this.activated) return false;
	this.activated = false;
	let self       = this;
	function readycallback(keep) {
		if (self.rendered) {
			self.launchOutro(keep);
		} else {
			self.outroReady(keep);
		}
		self.activated = false;
		self           = null;
	}
	console.log(this.controllersGroups);

	if (this.controllersGroups) {
		let l = 0;
		for (let gid in this.controllersGroups) {
			l++;
		}
		console.log(l);
		if (l) {
			for (let gid in this.controllersGroups) {
				let group = this.controllersGroups[gid];
				group.events.ongroupoutrodone.add(function () {
					l--;
					if (l == 0) {
						readycallback();
						readycallback = null;
					}
				});
			}
			this.events.beforedeactivate.dispatch(this);
		} else {
			this.events.beforedeactivate.dispatch(this);
			readycallback();
			readycallback = null;
		}
	} else {
		this.events.beforedeactivate.dispatch(this);
		readycallback();
		readycallback = null;
	}
}*/
